(() => {
  const STYLE_ID = 'prime-product-wishlist-style';
  const SELECTOR = "joy-wishlist-button[type='product']";

  const styles = `
    :host([type='product']) {
      display: block;
      width: 100%;
      margin-top: 12px;
    }

    :host([type='product']) .Joy-Wishlist__Button {
      isolation: isolate;
      position: relative;
      width: 100%;
      max-width: none;
      min-height: 54px;
      gap: 12px;
      overflow: hidden;
      padding: 10px 18px;
      border: 1px solid rgba(5, 24, 55, 0.18) !important;
      border-radius: 14px;
      background: linear-gradient(135deg, #ffffff 0%, #f4f7fb 100%) !important;
      color: #051837 !important;
      box-shadow: 0 5px 16px rgba(5, 24, 55, 0.07);
      font-size: 15px;
      font-weight: 750;
      letter-spacing: 0.01em;
      transition:
        transform 180ms ease,
        border-color 180ms ease,
        box-shadow 180ms ease,
        background 180ms ease,
        color 180ms ease;
    }

    :host([type='product']) .Joy-Wishlist__Button::before {
      content: '';
      position: absolute;
      z-index: -1;
      inset: 0;
      background: linear-gradient(110deg, transparent 25%, rgba(255, 255, 255, 0.7) 48%, transparent 72%);
      transform: translateX(-115%);
      transition: transform 500ms ease;
      pointer-events: none;
    }

    :host([type='product']) .Joy-Wishlist__Button:hover {
      border-color: rgba(5, 24, 55, 0.32) !important;
      box-shadow: 0 9px 22px rgba(5, 24, 55, 0.13);
      transform: translateY(-2px);
    }

    :host([type='product']) .Joy-Wishlist__Button:hover::before {
      transform: translateX(115%);
    }

    :host([type='product']) .Joy-Wishlist__Button:active {
      box-shadow: 0 3px 9px rgba(5, 24, 55, 0.1);
      transform: translateY(0) scale(0.99);
    }

    :host([type='product']) .Joy-Wishlist__Button:focus-visible {
      outline: 3px solid rgba(200, 16, 46, 0.3);
      outline-offset: 3px;
    }

    :host([type='product']) .Joy-Wishlist-WishlistButton__Icon {
      display: grid;
      width: 34px;
      height: 34px;
      flex: 0 0 34px;
      margin: 0;
      place-items: center;
      border: 1px solid rgba(200, 16, 46, 0.14);
      border-radius: 50%;
      background: #fff0f2;
      color: #c8102e !important;
      transition: transform 180ms ease, background 180ms ease;
    }

    :host([type='product']) .Joy-Wishlist-WishlistButton__Icon svg,
    :host([type='product']) .Joy-Wishlist-WishlistButton__Icon img {
      width: 18px;
      height: 18px;
    }

    :host([type='product']) .Joy-Wishlist__Button:hover .Joy-Wishlist-WishlistButton__Icon {
      transform: scale(1.08) rotate(-5deg);
    }

    :host(.prime-wishlist-added) .Joy-Wishlist__Button {
      border-color: #051837 !important;
      background: linear-gradient(135deg, #051837 0%, #0b315f 100%) !important;
      color: #ffffff !important;
      box-shadow: 0 8px 22px rgba(5, 24, 55, 0.22);
    }

    :host(.prime-wishlist-added) .Joy-Wishlist-WishlistButton__Icon {
      border-color: rgba(255, 255, 255, 0.22);
      background: #ffffff;
      color: #c8102e !important;
    }

    @media (prefers-reduced-motion: reduce) {
      :host([type='product']) .Joy-Wishlist__Button,
      :host([type='product']) .Joy-Wishlist__Button::before,
      :host([type='product']) .Joy-Wishlist-WishlistButton__Icon {
        transition: none;
      }
    }
  `;

  const enhance = (host) => {
    if (!host.shadowRoot) return false;

    if (!host.shadowRoot.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = styles;
      host.shadowRoot.appendChild(style);
    }

    const syncState = () => {
      const button = host.shadowRoot.querySelector('button');
      const label = button?.getAttribute('aria-label') || button?.textContent || '';
      host.classList.toggle('prime-wishlist-added', /^added\b/i.test(label.trim()));
    };

    syncState();

    if (!host.primeWishlistObserver) {
      host.primeWishlistObserver = new MutationObserver(syncState);
      host.primeWishlistObserver.observe(host.shadowRoot, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    return true;
  };

  const enhanceAll = () => {
    document.querySelectorAll(SELECTOR).forEach((host) => {
      if (!enhance(host)) window.setTimeout(() => enhance(host), 100);
    });
  };

  enhanceAll();

  const pageObserver = new MutationObserver(enhanceAll);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
